import { z } from "zod";
const UserOperationCallDataSchema = z.object({
    target: z.string().regex(/^0x[a-fA-F0-9]{40}$/),
    data: z.string().regex(/^0x[a-fA-F0-9]+$/),
    value: z.bigint().optional(),
});
export const validateUserOperationCallData = (data) => {
    return UserOperationCallDataSchema.safeParse(data);
};
